import { Results as LastAddedItemMethod } from '@ori-events/loyalty-dialog-result';
import Data from './Data';
import { ILastAddedItem } from './ILastAddedItem';
import { IReplacementItem, IShoppingBagItem } from './IShoppingBagItem';
import { IShoppingBagOffer } from './IShoppingBagOffer';
export var Name = 'basket-updated';
export var BasketUpdatedEvent = Name;
export { Data, ILastAddedItem, IReplacementItem, IShoppingBagItem, IShoppingBagOffer, LastAddedItemMethod };
export { IShoppingMessage, IProgressBarItems } from './IShoppingMessage';